// src/hooks/products/useCreateProduct.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createProduct } from "../../api/apiProducts";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

const useCreateProduct = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createProductMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: createProduct,
        onSuccess: (response) => {
            toast.success(response.message);
            navigate('/products');
            queryClient.invalidateQueries({ queryKey: ["products"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create product");
        },
    });

    return {
        createProductMutate,
        isPending: isPending || isLoading,
    };
};

export default useCreateProduct;
